export default __webpack_public_path__ + "static/media/img-proj-tokenization.fd53ecf4.png";